import { createContext, type PropsWithChildren, useContext, useRef, useState } from 'react';
import type { CarouselContext } from './Carousel.types';

const CarouselContext = createContext<CarouselContext>({
  isInitialized: false,
  progress: null,
  setProgress: () => false,
  isAtStart: true,
  setIsAtStart: () => false,
  isAtEnd: false,
  setIsAtEnd: () => false,
  setIsInitialized: () => false,
  setSwiperTouched: () => false,
  swiperRef: { current: null },
  swiperTouched: false,
});

export function useCarouselContext() {
  const ctx = useContext(CarouselContext);

  if (ctx === undefined) {
    throw new Error(`useCarouselContext must be used within a CarouselContext.Provider`);
  }

  return ctx;
}

export function CarouselProvider({ children }: PropsWithChildren) {
  const swiperRef = useRef(null);
  const [swiperTouched, setSwiperTouched] = useState<boolean>(false);
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [progress, setProgress] = useState<number | null>(null);
  const [isAtStart, setIsAtStart] = useState<boolean>(true);
  const [isAtEnd, setIsAtEnd] = useState<boolean>(false);

  return (
    <CarouselContext.Provider
      value={{
        isInitialized,
        progress,
        isAtStart,
        isAtEnd,
        setIsAtStart,
        setIsAtEnd,
        setProgress,
        setIsInitialized,
        setSwiperTouched,
        swiperTouched,
        swiperRef,
      }}
    >
      {children}
    </CarouselContext.Provider>
  );
}
